import React from "react"
import { Route, IndexRoute } from "react-router"
import App from "./App"
// App
import NotFoundPage from "./NotFoundPage"

// Debug
import EditorV2 from "features/editor"
import Test from "features/Test"

// Auth
import LoginPage from "features/auth/LoginPage"
import SignupPage from "features/auth/SignupPage"

// Account Pages
import StacksPage from "features/studio/containers/StacksPage"

// Studio
import AppListPage from "features/studio/containers/AppListPage"
import AppDetailPage from "features/studio/containers/AppDetailPage"
import PageListPage from "features/studio/containers/PageListPage"
import BlockListPage from "features/studio/containers/BlockListPage"
import PageEditor from "features/studio/containers/PageEditor"
import BlockEditor from "features/studio/containers/BlockEditor"
import ObjectListPage from "features/studio/containers/ObjectListPage"
import ObjectDetailPage from "features/studio/containers/ObjectDetailPage"
import RecordListPage from "features/studio/containers/RecordListPage"
import RecordDetailPage from "features/studio/containers/RecordDetailPage"
import Studio from "features/studio/Studio"
import MenuPage from "features/studio/containers/MenuPage"
import TemplateListPage from "features/studio/containers/TemplateListPage"

// Preview Pages
import ViewPageFromUrl from "features/pages/ViewPageFromUrl"

export default (
    <Route path="/" component={App}>
        <IndexRoute component={StacksPage} onEnter={requireAuth} />
        <Route path="preview/*" component={ViewPageFromUrl} onEnter={requireAuth} />
        <Route path="stacks" component={StacksPage} onEnter={requireAuth} />
        {/* Auth */}
        <Route path="register" component={SignupPage} section={"Login"} />
        <Route path="login" component={LoginPage} section={"Login"} />
        <Route path="logout" component={LoginPage} onEnter={logOut} />
        {/* Test Stuff */}
        <Route path="v2" component={EditorV2} onEnter={requireAuth} />
        <Route path="test" component={Test} section={"Data"} onEnter={requireAuth} />
        <Route path="apps" component={AppListPage} section={"Apps"} onEnter={requireAuth} />
        <Route path="data" component={ObjectListPage} section={"Data"} onEnter={requireAuth} />
        <Route path="tables" component={ObjectListPage} section={"Data"} onEnter={requireAuth} />
        <Route path="users" component={ObjectListPage} section={"Data"} onEnter={requireAuth} />
        <Route
            path="table/:objectId"
            component={ObjectDetailPage}
            section={"Data"}
            parent={"data"}
            onEnter={requireAuth}
        />
        <Route
            path="table/:objectId/records"
            component={RecordListPage}
            section={"Data"}
            parent={"data"}
            onEnter={requireAuth}
        />
        <Route
            path="record/:recordId"
            component={RecordDetailPage}
            section={"Data"}
            parent={"data"}
            onEnter={requireAuth}
        />
        <Route path="pages" component={PageListPage} section={"Apps"} onEnter={requireAuth} />{" "}
        <Route
            path="page/:pageId"
            component={PageEditor}
            section={"Apps"}
            parent={"page"}
            onEnter={requireAuth}
        />
        <Route path="blocks" component={BlockListPage} section={"Apps"} onEnter={requireAuth} />{" "}
        <Route
            path="blocks/:blockId"
            component={BlockEditor}
            section={"Apps"}
            parent={"block"}
            onEnter={requireAuth}
        />
        <Route
            path="apps/:appId/pages"
            component={PageListPage}
            section={"Apps"}
            onEnter={requireAuth}
        />
        <Route
            path="apps/:appId"
            component={AppDetailPage}
            section={"Apps"}
            onEnter={requireAuth}
        />
        <Route
            path="apps/:appId/menus"
            component={MenuPage}
            section={"Apps"}
            onEnter={requireAuth}
        />
        <Route
            path="apps/:appId/theme"
            component={PageListPage}
            section={"Apps"}
            onEnter={requireAuth}
        />
        <Route path="templates" component={TemplateListPage} onEnter={requireAuth} />
        <Route path="workflows" component={Studio} section={"Workflows"} onEnter={requireAuth} />
        {/* Four oh Four */}
        <Route path="*" component={NotFoundPage} />
    </Route>
)

export function requireAuth(nextState, replace, next) {
    // Allow us to log in directly to an org by passing in the right token
    let searchString = nextState.location.query
    if (searchString.api_token) {
        let token = searchString.api_token
        localStorage.setItem("studio_token", token)
    }

    // localStorage.setItem("page_token", "")
    let authenticated = localStorage.getItem("studio_token")
    if (!authenticated) {
        replace({
            pathname: "/login",
            state: { nextPathname: nextState.location.pathname },
        })
    }
    next()
}

// function publicPageAuth(nextState, replace, next) {
//     let pageId = nextState.params.pageId
//     fetch(settings.API_ROOT + "/api/pages/" + pageId + "/?public=true")
//         .then(pageResponse => {
//             return pageResponse.json()
//         })
//         .then(page => {
//             localStorage.setItem("page_token", page.params.params.token)
//             next()
//         })
// }

export function logOut(nextState, replace, next) {
    window.Intercom("boot", {
        app_id: (window.location.hostname === "studio.stacker.app" ? "txwvzciy" : "bu5482h5"),
        //Logged out user so may not have any user related info
    })
    localStorage.setItem("studio_token", "")
    localStorage.setItem("user_token", "")
    next()
}

//     <Route path="objects" component={ObjectListPage} onEnter={requireAuth} />
//     <Route path="object/:objectId" component={ObjectDetailPage} onEnter={requireAuth} />
//     <Route path="o/:objectId/*" component={ItemListPage} onEnter={requireAuth} />
//     <Route path="i/:itemId/*" component={ItemDetailPage} onEnter={requireAuth} />
//     <Route path="v/:viewId/*" component={ItemViewListPage} onEnter={requireAuth} />
//     <Route path="sheet" component={SpreadsheetPage} onEnter={requireAuth} />
//     <Route path="workflows/add" component={AddWorkflowPage} onEnter={requireAuth} />
//     <Route path="workflows" component={WorkflowPage} onEnter={requireAuth} />
//     <Route
//         path="email-templates/edit/:templateId/"
//         component={EmailTemplateEditorPage}
//         onEnter={requireAuth}
//     />
//     <Route
//         path="email-templates/edit"
//         component={EmailTemplateEditorPage}
//         onEnter={requireAuth}
//     />
//     <Route path="email-templates" component={EmailTemplateListPage} onEnter={requireAuth} />
//     <Route path="roles" component={RoleListPage} onEnter={requireAuth} />
//     <Route path="roles/:roleId/" component={RoleDetailPage} onEnter={requireAuth} />
//     <Route path="perms" component={EditPermissionsPage} onEnter={requireAuth} />
//     <Route path="api/docs" component={ApiDocs} onEnter={requireAuth} />
//     <Route path="login" component={LoginPage} />
//     <Route path="logout" component={LoginPage} onEnter={logOut} />
//     <Route path="p/:pageId/public/(:getParams)" component={Builder} onEnter={publicPageAuth}/>
// <Route path="p/:pageId/:isEdit/" component={Builder} onEnter={requireAuth}/>
// <Route path="p/:pageId/(:getParams)" component={Builder} onEnter={requireAuth}/> */}
//      <Route path="builder/" component={Builder} onEnter={requireAuth} />
//     <Route path="pages/" component={PageListPage} onEnter={requireAuth} />
//     <Route path="apps/" component={AppsListPage} onEnter={requireAuth} />
//     <Route path="editor/(:pageId)(/)(:itemId)(/)" component={Editor} onEnter={requireAuth} />
//     <Route path="p/(:pageId)(/)(:itemId)(/)" component={Viewer} onEnter={requireAuth} />
//     <Route path="p/(:pageId)" component={Viewer} onEnter={requireAuth} />
//     <Route path="public/(:pageId)" component={Viewer} onEnter={publicPageAuth} /> */}{" "}



// WEBPACK FOOTER //
// ./src/app/routes.js